export default __webpack_public_path__ + "static/media/04dbb8de-bad0-44b2-93fe-3437ceaece7b.e7ccecc0.jpeg";